define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'canvas/ConnectionCanvas',
	'lib/jquery'
], function (
	Util,
	UiUtil,
	ConnectionCanvas,
	jQuery
) {
	'use strict';

	/**
	 * ConnectionView class
	 */
	return function () {
		var _connectionCanvas = new ConnectionCanvas(),
			_view;

		_view = (function () {
			var $view = jQuery(
				"<div id='skIdS_connection-container'>" +
					"<img id='skIdS_server-symbol' src='" + UiUtil.getImage('SERVER_ICON').url() + "' alt='Server'>" +
				"</div>");

			$view.prepend(jQuery(_connectionCanvas.get()).attr('id', 'skIdS_connection-symbol'));

			return $view;
		})();


		// public methods

		this.get = function () {
			return _view;
		};

		this.enableAnimation = function () {
			_connectionCanvas.enableAnimation();
		};

		this.disableAnimation = function () {
			_connectionCanvas.reset();
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/ConnectionView.js
// module id = 319
// module chunks = 1